// Page views vs watch views per time bucket (bucket size matches the concurrent chart).
function formatBucketTime(value) {
  return new Date(value).toLocaleString([], { month: "short", day: "2-digit", hour: "2-digit", minute: "2-digit" });
}

export default function ViewsOverTimeChart({ data = [] }) {
  const max = Math.max(1, ...data.map((point) => point.page_views || 0));

  return (
    <section className="rounded-xl border border-slate-200 bg-white p-5 shadow-sm">
      <h2 className="text-lg font-semibold text-slate-950">Views over time</h2>
      <p className="text-sm text-slate-500">New visits per period (light) and how many of them played the video (solid).</p>
      {data.length ? (
        <>
          <div className="mt-5 flex h-40 items-end gap-px overflow-x-auto rounded-lg bg-slate-50 p-2" data-testid="views-over-time">
            {data.map((point) => (
              <div
                key={point.timestamp}
                className="relative flex h-full min-w-[6px] flex-1 items-end"
                title={`${formatBucketTime(point.timestamp)} — ${point.page_views} views, ${point.watch_views} watched`}
              >
                <div className="w-full rounded-t bg-[#FF3A20]/20" style={{ height: `${(point.page_views / max) * 100}%` }} />
                <div className="absolute bottom-0 w-full rounded-t bg-[#FF3A20]" style={{ height: `${(point.watch_views / max) * 100}%` }} />
              </div>
            ))}
          </div>
          <div className="mt-2 flex justify-between text-xs text-slate-500">
            <span>{formatBucketTime(data[0].timestamp)}</span>
            <span>Max {max} views per period</span>
            <span>{formatBucketTime(data[data.length - 1].timestamp)}</span>
          </div>
        </>
      ) : (
        <p className="mt-5 text-sm text-slate-500">No views recorded yet.</p>
      )}
    </section>
  );
}
